"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setNoScroll = void 0;
var _noScroll = _interopRequireDefault(require("no-scroll"));
var _env = _interopRequireDefault(require("../env/env"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
// Prevent the document from scrolling.  Useful if e.g. modal is
// showing and you don't want the background to be scrollable.
var setNoScroll = exports.setNoScroll = function setNoScroll(isModalOpen, disableModalAttributes) {
  if (_env["default"].isClient) {
    if (isModalOpen) {
      _noScroll["default"].on();
      if (!disableModalAttributes) {
        document.documentElement.setAttribute('data-modal', 'true');
      }
    } else {
      _noScroll["default"].off();
      if (!disableModalAttributes) {
        document.documentElement.setAttribute('data-modal', 'false');
      }
    }
  }
};